export default function extractYoutubeEmbedUrl(url) {
  if (url.match(/https:\/\/www\.youtube\.com\/watch\?v=.*/)) {
    return addAutoPlayToYoutubeEmbedUrl(url.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/'))
  }
  else if (url.match(/https:\/\/music\.youtube\.com\/watch\?v=.*/)) {
    return addAutoPlayToYoutubeEmbedUrl(url.replace('https://music.youtube.com/watch?v=', 'https://www.youtube.com/embed/'))
  }
  // https://www.youtube.com/playlist?list=PLvGwhu4qfrTzhJsWtmxPXfC02wKrk9nyc
  else if (url.match(/https:\/\/www\.youtube\.com\/playlist\?list=.*/)) {
    return url.replace('https://www.youtube.com/playlist?list=', 'https://www.youtube.com/embed/videoseries?list=')
  }
  // https://music.youtube.com/playlist?list=PL6F2zbEoO1ZHnVG6XBGiVjALu-7gS0PsE
  else if (url.match(/https:\/\/music\.youtube\.com\/playlist\?list=.*/)) {
    return url.replace('https://music.youtube.com/playlist?list=', 'https://www.youtube.com/embed/videoseries?list=')
  }
  else {
    return null
  }
}

function addAutoPlayToYoutubeEmbedUrl(url) {
  if(url.includes('autoplay=1')) {
    return url
  }
  else if(url.includes('?')) {
    return `${url}&autoplay=1`
  }
  else {
    return `${url}?autoplay=1`
  }
}

